function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo } from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext } from "../index";
import Select from "react-select";
import { HiDownload } from "react-icons/hi";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import "./CustomReport.css";
import { GET_EMAIL_REPORT_QUERY, EMAIL_REPORT_ORGANISATION_TEAM_QUERY } from "./query";
import { useQuery, useLazyQuery } from "@apollo/client";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Popover from "react-bootstrap/Popover";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { TimeFilter } from "./../ProjectReport/DateFilter";
import { arrayToStringOutput, startOfDayCheck, endOfDayCheck } from "./../SideMenu/Header";
var CustomReport = function CustomReport(props) {
  var yesterDayDate = new Date(Date.now() - 86400000);
  //console.log("new Date ", new Date(Date.now() - 86400000) );

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "report-details-root"
  }, /*#__PURE__*/React.createElement(ReportDetails, {
    yesterDayDate: yesterDayDate,
    history: props.history
  })));
};
var ReportDetails = function ReportDetails(props) {
  var _teamListData$emailRe;
  var yesterDayDate = props.yesterDayDate,
    history = props.history;
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    organisationStatus = _React$useContext.organisationStatus,
    organisationUserCount = _React$useContext.organisationUserCount;
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //const [startDate, setStartDate] = React.useState(yesterDayDate);
  var _React$useState = React.useState({
      startDate: startOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().startOf("day").toDate() : endOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().endOf("days").toDate() : moment().tz(currentTimezone).clone().toDate(),
      endDate: null
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dates = _React$useState2[0],
    setDate = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    teamParameterCheck = _React$useState4[0],
    setTeamParameterCheck = _React$useState4[1];
  var _React$useState5 = React.useState({
      team: true,
      organisation: false
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    reportType = _React$useState6[0],
    setReportType = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    exportButton = _React$useState8[0],
    setExportButton = _React$useState8[1];
  var _React$useState9 = React.useState(true),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    totalWorkedTime = _React$useState10[0],
    setTotalWorkedTime = _React$useState10[1];
  var _React$useState11 = React.useState(true),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    idleTime = _React$useState12[0],
    setIdleTime = _React$useState12[1];
  var _React$useState13 = React.useState(true),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    activeTime = _React$useState14[0],
    setActiveTime = _React$useState14[1];
  var _React$useState15 = React.useState(true),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    clockIn = _React$useState16[0],
    setClockIn = _React$useState16[1];
  var _React$useState17 = React.useState(true),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    clockOut = _React$useState18[0],
    setClockOut = _React$useState18[1];
  var _React$useState19 = React.useState(true),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    productiveTime = _React$useState20[0],
    setProductiveTime = _React$useState20[1];
  var _React$useState21 = React.useState(true),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    unproductiveTime = _React$useState22[0],
    setUnproductiveTime = _React$useState22[1];
  var _React$useState23 = React.useState(true),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    neutralTime = _React$useState24[0],
    setNeutralTime = _React$useState24[1];
  var _React$useState25 = React.useState(true),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    breakTime = _React$useState26[0],
    setBreakTime = _React$useState26[1];
  var _React$useState27 = React.useState(0),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    loopInit = _React$useState28[0],
    setLoopInit = _React$useState28[1];
  var _React$useState29 = React.useState([]),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    allUsers = _React$useState30[0],
    setAllUsers = _React$useState30[1];
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var startDate = dates.startDate,
    endDate = dates.endDate;
  var _React$useState31 = React.useState(arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    filterData = _React$useState32[0],
    setFilterData = _React$useState32[1];
  var filterDaysDiff = Math.ceil(moment.duration(moment(endDate).diff(startDate)).asDays());
  var exportOffsets = 0;
  var exportLimit = filterDaysDiff >= 15 && organisationUserCount >= 100 ? 100 : 0;
  // let exportLimit = 50;

  var loopCount = exportLimit != 0 ? Number(Math.ceil(organisationUserCount / exportLimit)) + 1 : 1;
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var teamList = [{
    label: "All Teams",
    value: "all"
  }];
  var _useQuery = useQuery(EMAIL_REPORT_ORGANISATION_TEAM_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: user.userId
      },
      skip: !organisationId
    }),
    teamListData = _useQuery.data,
    teamListError = _useQuery.error,
    teamListLoading = _useQuery.loading;
  var _useLazyQuery = useLazyQuery(GET_EMAIL_REPORT_QUERY, {
      // A rate-limited export (429) never returns data, and exportButton is
      // cleared on the data path only - without this the export button stays
      // loading until the page is reloaded. The message itself is shown by the
      // errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    exportData = _useLazyQuery2$.data;
  var csvData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(getEmailReport) {
      var dataArray, dataValues, wb, ws, col, buf, fileName;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dataArray = [];
            dataValues = getEmailReport;
            if (dataValues) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", []);
          case 4:
            wb = new Excel.Workbook();
            ws = wb.addWorksheet();
            col = [{
              header: "Display Name",
              key: "displayName",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Employee ID",
              key: "employeeId",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Team",
              key: "team",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "EmailId",
              key: "emailId",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Date",
              key: "date",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }];
            if (clockIn) {
              col.push({
                header: "ClockIn",
                key: "clockIn",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (clockOut) {
              col.push({
                header: "ClockOut",
                key: "clockOut",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (totalWorkedTime) {
              col.push({
                header: "Total Work Hour",
                key: "totalWorkHours",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (activeTime) {
              col.push({
                header: "Active Hour",
                key: "activeTime",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (idleTime) {
              col.push({
                header: "Idle Hour",
                key: "idleTime",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (productiveTime) {
              col.push({
                header: "Productive Apps Time",
                key: "productiveTime",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (unproductiveTime) {
              col.push({
                header: "Unproductive Apps Time",
                key: "unproductiveTime",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (neutralTime) {
              col.push({
                header: "Neutral Apps Time",
                key: "neutralTime",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            if (breakTime) {
              col.push({
                header: "Break Time",
                key: "breakTime",
                style: {
                  alignment: {
                    vertical: "middle",
                    horizontal: "left"
                  }
                }
              });
            }
            ws.columns = col;
            dataValues.map(function (item, index) {
              item.days.map(function (d, index) {
                var totalWorkSec = d.totalWorkSec,
                  totalWorkHours = d.totalWorkHours,
                  idleSec = d.idleSec,
                  idleHours = d.idleHours,
                  productiveSec = d.productiveSec,
                  productiveHours = d.productiveHours,
                  unproductiveSec = d.unproductiveSec,
                  unproductiveHours = d.unproductiveHours,
                  neutralSec = d.neutralSec,
                  neutralHours = d.neutralHours,
                  activeHours = d.activeHours,
                  breakHours = d.breakHours,
                  user = d.user,
                  dateForExport = d.dateForExport;
                var clockIn = d.clockIn,
                  clockOut = d.clockOut;
                clockIn = clockIn === "-" ? "--" : moment(Number(clockIn)).format("hh:mm:ss a");
                clockOut = clockOut === "-" ? "--" : moment(Number(clockOut)).format("hh:mm:ss a");
                var date = endDate ? "".concat(moment(startDate).format("DD MMM YYYY"), "-").concat(moment(endDate).format("DD MMM YYYY")) : "".concat(moment(startDate).format("DD MMM YYYY"));
                var t = {
                  displayName: item.user.displayName,
                  team: item.user.team,
                  emailId: item.user.emailId,
                  date: dateForExport,
                  employeeId: item.user.employeeId
                };
                if (clockIn) {
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    clockIn: clockIn
                  });
                }
                if (clockOut) {
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    clockOut: clockOut
                  });
                }
                if (totalWorkedTime) {
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    totalWorkHours: totalWorkHours
                  });
                }
                if (activeTime) {
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    activeTime: activeHours
                  });
                }
                if (idleTime) {
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    idleTime: idleHours
                  });
                }
                if (productiveTime) {
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    productiveTime: productiveHours
                  });
                }
                if (unproductiveTime) {
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    unproductiveTime: unproductiveHours
                  });
                }
                if (neutralTime) {
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    neutralTime: neutralHours
                  });
                }
                if (breakTime) {
                  t = _objectSpread(_objectSpread({}, t), {}, {
                    breakTime: breakHours
                  });
                }
                ws.addRow(t);
                return dataArray.push(t);
              });
              return;
            });
            ws.getRow(1).font = {
              bold: true
            };
            _context.next = 21;
            return wb.xlsx.writeBuffer();
          case 21:
            buf = _context.sent;
            // const fileName = `workfolio-custom-report-${moment(Number(startDate)).format("DD-MMM")} - ${moment(
            //   Number(endDate)
            // ).format("DD-MMM")}.xlsx`;
            fileName = "workfolio-custom-report-".concat(moment(Number(startDate)).format("DD-MMM"), ".xlsx");
            if (endDate != null) {
              fileName = "workfolio-custom-report-".concat(moment(Number(startDate)).format("DD-MMM"), "-").concat(moment(Number(endDate)).format("DD-MMM"), ".xlsx");
            }
            saveAs(new Blob([buf]), fileName);

            // const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            // const fileExtension = ".xlsx";
            // const fileName = `workfolio-custom-report-${moment(Number(startDate)).format("DD-MMM")}`;

            // const ws = XLSX.utils.json_to_sheet(dataArray);
            // const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            // const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            // const data = new Blob([excelBuffer], { type: fileType });
            // FileSaver.saveAs(data, fileName + fileExtension);

            setExportButton(false);
            setLoopInit(0);
            setAllUsers([]);
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function csvData(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  React.useEffect(function () {
    setLoopInit(0);
    exportOffsets = 0;
    setAllUsers([]);
  }, [startDate]);
  React.useEffect(function () {
    csvData();
  }, [exportData]);
  React.useEffect(function () {
    if (teamParameterCheck === null) {
      setTeamParameterCheck({
        label: "All Teams",
        value: "all"
      });
    }
  }, [teamListData]);
  teamListData === null || teamListData === void 0 ? void 0 : (_teamListData$emailRe = teamListData.emailReportOrganisationTeams) === null || _teamListData$emailRe === void 0 ? void 0 : _teamListData$emailRe.map(function (item) {
    var label = item.label,
      value = item.value;
    return teamList.push({
      label: label,
      value: value
    });
  });
  var getExportData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setExportButton(true);
            setLoopInit(loopInit + 1);
            getExport({
              variables: {
                organisationId: organisationId,
                startDate: Number(moment(startDate).format("x")),
                endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                reportType: reportType !== null && reportType !== void 0 && reportType.team ? "team" : "organisation",
                teamId: (teamParameterCheck === null || teamParameterCheck === void 0 ? void 0 : teamParameterCheck.value) === "" && !reportType.team ? null : teamParameterCheck === null || teamParameterCheck === void 0 ? void 0 : teamParameterCheck.value,
                userRole: role,
                limit: exportLimit,
                offset: exportOffsets
              }
            });
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getExportData() {
      return _ref2.apply(this, arguments);
    };
  }();
  React.useEffect(function () {
    //exportButton
    if (exportData !== null && exportData !== void 0 && exportData.getEmailReport) {
      var dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.getEmailReport;
      if (!dataValues) {
        return [];
      }
      if (exportLimit != 0) {
        setAllUsers(function (prevUsers) {
          return [].concat(_toConsumableArray(prevUsers), _toConsumableArray(dataValues));
        });
        if (loopInit <= loopCount) {
          exportOffsets = loopInit * exportLimit;
          setLoopInit(loopInit + 1);
          getExport({
            variables: {
              organisationId: organisationId,
              startDate: Number(moment(startDate).format("x")),
              endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
              timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
              reportType: reportType !== null && reportType !== void 0 && reportType.team ? "team" : "organisation",
              teamId: (teamParameterCheck === null || teamParameterCheck === void 0 ? void 0 : teamParameterCheck.value) === "" && !reportType.team ? null : teamParameterCheck === null || teamParameterCheck === void 0 ? void 0 : teamParameterCheck.value,
              userRole: role,
              limit: exportLimit,
              offset: exportOffsets
            }
          });
        }
        if (allUsers.length && loopInit == loopCount) {
          csvData(allUsers);
        }
      } else {
        csvData(dataValues);
      }
    }
  }, [exportData]);
  var onFilterChange = function onFilterChange(dates) {
    setDate(dates);
  };
  var hideOverlay = function hideOverlay() {
    var _document, _document$body, _document$body$click;
    (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$click = _document$body.click) === null || _document$body$click === void 0 ? void 0 : _document$body$click.call(_document$body);
  };
  var selectTimeAllCheck = function selectTimeAllCheck() {
    if (totalWorkedTime && idleTime && activeTime && clockIn && clockOut && productiveTime && unproductiveTime && neutralTime && breakTime) {
      return true;
    }
    return false;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "report-details-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "report-details-content-report-type"
  }, /*#__PURE__*/React.createElement("label", {
    className: "report-details-label"
  }, "Select Date"), /*#__PURE__*/React.createElement("div", {
    className: "report-details-date-picker"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    rootClose: true,
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Popover, {
      className: "page-content-wrapper-menu-filter-overlay-trigger"
    }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(TimeFilter, {
      onFilterChange: onFilterChange,
      startDate: startDate,
      endDate: endDate,
      filterData: filterData,
      onClose: hideOverlay,
      organisationBilling: organisationBilling,
      organisationSettings: organisationSettings
    })))
  }, /*#__PURE__*/React.createElement("div", {
    id: "date-filter",
    className: "custom-report-page-content-wrapper-menu-filter-date"
  }, /*#__PURE__*/React.createElement("p", {
    className: "custom-report-page-content-wrapper-menu-filter-date-text"
  }, arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)))))), /*#__PURE__*/React.createElement("div", {
    className: "report-details-content-report-type"
  }, /*#__PURE__*/React.createElement("label", {
    className: "report-details-label"
  }, "Report Type"), /*#__PURE__*/React.createElement("div", {
    className: "report-details-input-content"
  }, /*#__PURE__*/React.createElement("span", null, " ", /*#__PURE__*/React.createElement("input", {
    type: "radio",
    value: "summary",
    name: "reportType",
    checked: reportType.team,
    onChange: function onChange(prev) {
      return setReportType(reportType.team ? {
        team: false
      } : {
        team: true
      });
    }
  }), " ", "Team Summary"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    value: "detailed",
    name: "reportType",
    checked: reportType.organisation,
    onChange: function onChange(prev) {
      return setReportType(reportType.organisation ? {
        organisation: false
      } : {
        organisation: true
      });
    }
  }), " ", "Organization Summary"))), reportType.team ? /*#__PURE__*/React.createElement("div", {
    className: "report-details-content-report-type"
  }, /*#__PURE__*/React.createElement("label", {
    className: "report-details-label"
  }, "Select Team"), /*#__PURE__*/React.createElement("div", {
    className: "report-details-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: teamParameterCheck,
    onChange: function onChange(e) {
      return setTeamParameterCheck(e);
    },
    options: teamList,
    className: "report-details-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: "report-details-content-report-type"
  }, /*#__PURE__*/React.createElement("div", {
    className: "report-details-time-label-div"
  }, /*#__PURE__*/React.createElement("label", {
    className: "report-details-label"
  }, "Time"), selectTimeAllCheck() ? /*#__PURE__*/React.createElement("span", {
    className: "report-details-select-all-label",
    onClick: function onClick() {
      setTotalWorkedTime(false);
      setIdleTime(false);
      setActiveTime(false);
      setClockIn(false);
      setClockOut(false);
      setProductiveTime(false);
      setUnproductiveTime(false);
      setNeutralTime(false);
      setBreakTime(false);
    }
  }, "Unselect All") : /*#__PURE__*/React.createElement("span", {
    className: "report-details-select-all-label",
    onClick: function onClick() {
      setTotalWorkedTime(true);
      setIdleTime(true);
      setActiveTime(true);
      setClockIn(true);
      setClockOut(true);
      setProductiveTime(true);
      setUnproductiveTime(true);
      setNeutralTime(true);
      setBreakTime(true);
    }
  }, "Select All")), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "report-details-input-content report-details-time-content"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    value: "totalWorkedTime",
    name: "time",
    checked: totalWorkedTime,
    onChange: function onChange(e) {
      return setTotalWorkedTime(function (prevValue) {
        return !prevValue;
      });
    }
  }), /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return setTotalWorkedTime(function (prevValue) {
        return !prevValue;
      });
    }
  }, " Total Worked Time")), /*#__PURE__*/React.createElement("span", null, " ", /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    value: "activeTime",
    name: "time",
    checked: activeTime,
    onChange: function onChange(e) {
      return setActiveTime(function (prevValue) {
        return !prevValue;
      });
    }
  }), " ", /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return setActiveTime(function (prevValue) {
        return !prevValue;
      });
    }
  }, " Active Time")), /*#__PURE__*/React.createElement("span", null, " ", /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    value: "idleTime",
    name: "time",
    checked: idleTime,
    onChange: function onChange(e) {
      return setIdleTime(function (prevValue) {
        return !prevValue;
      });
    }
  }), " ", /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return setIdleTime(function (prevValue) {
        return !prevValue;
      });
    }
  }, " Idle Time")), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    value: "clockIn",
    name: "time",
    checked: clockIn,
    onChange: function onChange(e) {
      return setClockIn(function (prevValue) {
        return !prevValue;
      });
    }
  }), " ", /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return setClockIn(function (prevValue) {
        return !prevValue;
      });
    }
  }, " Clock In")), /*#__PURE__*/React.createElement("span", null, " ", /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    value: "clockOut",
    name: "time",
    checked: clockOut,
    onChange: function onChange(e) {
      return setClockOut(function (prevValue) {
        return !prevValue;
      });
    }
  }), " ", /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return setClockOut(function (prevValue) {
        return !prevValue;
      });
    }
  }, "Clock Out")), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    value: "productiveTime",
    name: "productivity",
    checked: productiveTime,
    onChange: function onChange(e) {
      return setProductiveTime(function (prevValue) {
        return !prevValue;
      });
    }
  }), " ", /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return setProductiveTime(function (prevValue) {
        return !prevValue;
      });
    }
  }, "Productive Apps Time")), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    value: "unproductiveTime",
    name: "time",
    checked: unproductiveTime,
    onChange: function onChange(e) {
      return setUnproductiveTime(function (prevValue) {
        return !prevValue;
      });
    }
  }), " ", /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return setUnproductiveTime(function (prevValue) {
        return !prevValue;
      });
    }
  }, "Unproductive Apps Time")), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    value: "neutralTime",
    name: "time",
    checked: neutralTime,
    onChange: function onChange(e) {
      return setNeutralTime(function (prevValue) {
        return !prevValue;
      });
    }
  }), " ", /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return setNeutralTime(function (prevValue) {
        return !prevValue;
      });
    }
  }, " Neutral Apps Time")), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    value: "breakTime",
    name: "time",
    checked: breakTime,
    onChange: function onChange(e) {
      return setBreakTime(function (prevValue) {
        return !prevValue;
      });
    }
  }), " ", /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return setBreakTime(function (prevValue) {
        return !prevValue;
      });
    }
  }, "Break Time"))))), (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? /*#__PURE__*/React.createElement("div", {
    className: "report-details-content-export-button"
  }, !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      getExportData();
    }
  }, " ", /*#__PURE__*/React.createElement(HiDownload, {
    className: "report-details-filter-download-icon"
  }), " Export as xlsx") : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    disabled: true
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "report-details-filter-download-icon"
  }), "Downloading")) : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet disable-custom-report-export"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export as xlsx")));
};
export default CustomReport;